__turbopack_context__.v({
  "container": "PhotoTips-module-scss-module__McZP3W__container",
  "imageContainer": "PhotoTips-module-scss-module__McZP3W__imageContainer",
  "list": "PhotoTips-module-scss-module__McZP3W__list",
});
